import { useMemo } from 'react';
import { useTenants } from '@/services/tenants/useTenants';

export const useIndexPage = () => {
  const { tenant } = useTenants();

  const indexPagePath = useMemo(() => {
    if (!tenant?.tenantShortName) {
      return '/tenants';
    }
    return `/tenants/${tenant.tenantShortName}/assets`;
  }, [tenant]);

  return {
    indexPagePath,
  };
};
